import { WORKFLOW_FIELDS } from '../fragments'

export default `
  ${WORKFLOW_FIELDS}
  mutation importWorkflow($workflowId: String!, $projectId: String!, $workflowData: AWSJSON!) {
    importWorkflow(workflowId: $workflowId, projectId: $projectId, workflowData: $workflowData) {
      ...WorkflowFields
    }
  }
`
